import {
	IonContent,
	IonPage,
	IonButton,
	IonInput,
	IonItem,
	IonLabel,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { registerUser, loginUser } from "../../../services/auth";
import { monitorUser, setUser } from "../../../services/users";
import { updateUser } from "../../../services/users";
import { connect } from "react-redux";

import { toast } from "../../../components/Toast/toast";
import { setLoading } from "../../../services/loading";
import Spacer from "../../../components/spacer";

interface RegisterProps {
	loggedIn: any;
	setUser: any;
	setLoading: any;
	monitorUser: any;
}

const Register: React.FC<RegisterProps> = ({
	loggedIn,
	setUser,
	setLoading,
	monitorUser,
}) => {
	const history = useHistory();

	const emailTest =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	useEffect(() => {
		if (loggedIn) {
			history.replace("/");
		}
		//eslint-disable-next-line
	}, [loggedIn]);

	async function register(e: any) {
		e.preventDefault();
		if (password !== confirmPassword) {
			return toast("Passwords do not match");
		}
		if (email.trim() === "" || password.trim() === "") {
			return toast("Email and/or password are empty");
		}
		if (!emailTest.test(String(email).toLowerCase())) {
			return toast("Email address is incorrect format");
		}
		setLoading(true, "Registering new user");

		registerUser(email, password).then((res: any) => {
			console.log(res);
			if (res) {
				updateUser(res, {});
				setLoading(false);
				toast("You have registered successfully!");
				setLoading(true, "Logging in");
				loginUser({ email, password }).then((res: any) => {
					if (res) {
						setUser(res.user);
						monitorUser(res.user.uid);
						history.replace("/dashboard");
						toast("You are logged in!");
					}
					setLoading(false);
				});
			}
		});
	}

	if (!loggedIn)
		return (
			<IonPage>
				<IonContent fullscreen className="ion-padding auth-screen">
					<div className="page-wrapper app-background">
						<div id="app-logo" />
						<div id="content-box">
							<h1 className="center-text instructions">Register</h1>
							<IonItem>
								<IonLabel position="floating">Your Email</IonLabel>
								<IonInput
									type="email"
									placeholder="Your Email"
									onIonChange={(e: any) => setEmail(e.target.value)}
								/>
							</IonItem>
							<Spacer size="15" />
							<IonItem>
								<IonLabel position="floating">Your Password</IonLabel>
								<IonInput
									type="password"
									placeholder="Password"
									onIonChange={(e: any) => setPassword(e.target.value)}
								/>
							</IonItem>
							<Spacer size="15" />
							<IonItem>
								<IonLabel position="floating">Confirm Password</IonLabel>
								<IonInput
									type="password"
									placeholder="Confirm Password"
									onIonChange={(e: any) => setConfirmPassword(e.target.value)}
								/>
							</IonItem>
							<Spacer size="15" />
							<IonButton expand="full" size="large" onClick={register}>
								Register
							</IonButton>
							<Spacer size="15" />
							{/* <p
								onClick={() => history.push("/")}
								className="linked instructions small center-text"
							>
								Already have an account? Login
							</p> */}
							<Link
								to="/"
								className="instructions small full-width center-text"
							>
								Already have an account? Login
							</Link>
						</div>
					</div>
				</IonContent>
			</IonPage>
		);
	else return null;
};

const mapStateToProps = (state: any) => ({
	loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {
	setUser,
	setLoading,
	monitorUser,
})(Register);
